module.exports = __webpack_public_path__ + "img/company-points-4.png";